<template>
  <div class="field col-12 md:col-6" v-if="event.id !== null">
    <label for="status">Status</label>
    <Dropdown
      id="status"
      v-model="v$.event.status.$model"
      placeholder="Selecione o status."
      :options="statusEvent"
      optionValue="key"
      optionLabel="name"
      :class="{ 'p-invalid': submitted && v$.event.status.$invalid }"
    />
    <small class="p-error" v-if="submitted && v$.event.status.$invalid"
      >Status é obrigatório.</small
    >
  </div>

  <div class="field col-12 md:col-6">
    <label for="name">Nome</label>
    <InputText
      id="name"
      v-model.trim="v$.event.name.$model"
      placeholder="Digite o nome do evento."
      autofocus
      :class="{ 'p-invalid': submitted && v$.event.name.$invalid }"
      @blur="mostraV"
    />
    <small class="p-error" v-if="submitted && v$.event.name.$invalid"
      >Nome é obrigatório. Máximo. 100.</small
    >
  </div>
  <div class="field col-12 md:col-6">
    <label for="local">Local</label>
    <Dropdown
      id="local"
      v-model="v$.event.local.$model"
      :options="locals"
      optionLabel="name"
      placeholder="Selecione o local do evento."
      :filter="true"
      @change="setParticipants()"
      :class="{
        'p-invalid': submitted && v$.event.local.$invalid,
      }"
    />
    <small class="p-error" v-if="submitted && v$.event.local.$invalid"
      >Local é obrigatório.</small
    >
  </div>
  <div class="field col-12 md:col-6">
    <label for="type">Tipo</label>
    <Dropdown
      id="type"
      v-model="v$.event.type.$model"
      placeholder="Selecione o tipo de evento"
      :class="{ 'p-invalid': submitted && v$.event.type.$invalid }"
      :options="types"
      optionValue="key"
      optionLabel="name"
      @change="changeShowEditor(v$.event.type.$model)"
    />
    <small class="p-error" v-if="submitted && v$.event.type.$invalid"
      >Tipo é obrigatório.</small
    >
  </div>
  <div class="field col-12 md:col-6">
    <label for="equipamento">Equipamentos</label>
    <MultiSelect
      id="equipamento"
      v-model="v$.event.equipaments.$model"
      :options="equipaments"
      optionLabel="name"
      placeholder="Selecione os equipamentos para o evento."
      multiple="true"
      :filter="true"
      :showClear="true"
      :class="{
        'p-invalid': submitted && v$.event.equipaments.$invalid,
      }"
    />
    <small class="p-error" v-if="submitted && v$.event.equipaments.$invalid"
      >Equipamento é obrigatório.</small
    >
  </div>
  <div class="field col-12 md:col-6">
    <label for="nparticipants">N° de Participantes</label>
    <InputText
      type="number"
      id="nparticipants"
      v-model="v$.event.nparticipants.$model"
      placeholder="Quantidade de Participantes."
      :class="{
        'p-invalid': submitted && v$.event.nparticipants.$invalid,
      }"
    />
    <small class="p-error" v-if="submitted && v$.event.nparticipants.$invalid"
      >N° participantes é obrigatório. Mínimo. {{ capMin }} | Máximo.
      {{ capMax }}.</small
    >
  </div>
  <div class="field col-12 md:col-6">
    <label for="pae">PAE</label>
    <InputMask
      id="pae"
      v-model.trim="v$.event.pae.$model"
      placeholder="Número do processo PAE."
      mask="9999/?99999999999999"
      autoClear="false"
      class="uperCase"
      aria-labelledby="basic"
      :class="{
        'p-invalid': submitted && v$.event.pae.$invalid && isPaeRequired(),
      }"
    />
    <small
      class="p-error"
      v-if="submitted && v$.event.pae.$invalid && isPaeRequired()"
      >Pae é obrigatório.</small
    >
  </div>
  <div class="field col-12 md:col-6">
    <label for="description">Descrição</label>
    <Textarea
      id="description"
      v-model="v$.event.description.$model"
      placeholder="Digite a descrição do evento"
      rows="5"
      cols="30"
      autoResize="false"
      :class="{
        'p-invalid': submitted && v$.event.description.$invalid,
      }"
    />
    <small class="p-error" v-if="submitted && v$.event.description.$invalid"
      >Descrição é obrigatório.</small
    >
  </div>

  <div class="field col-12 md:col-6" v-if="event.status == `CANCELED`">
    <label for="justificativa">Justificativa</label>
    <Textarea
      id="justificativa"
      v-model="v$.event.observation.$model"
      placeholder="Informe a justificativa do cancelamento."
      rows="5"
      cols="30"
      autoResize="false"
      :class="{ 'p-invalid': submitted && v$.event.observation.$invalid }"
    />
    <small class="p-error" v-if="submitted && v$.event.observation.$invalid"
      >Justificativa de cancelamento é obrigatório.</small
    >
  </div>
  <div class="field col-12 md:col-6" v-else>
    <label for="observation">Observação</label>
    <Textarea
      id="observation"
      v-model="v$.event.observation.$model"
      placeholder="Informe a observação"
      rows="5"
      cols="30"
      autoResize="false"
    />
  </div>

  <div class="field col-12" v-if="showEditor || event.participants">
    <label for="participants">Lista de Participantes</label>
    <Editor
      id="participants"
      v-model="v$.event.participants.$model"
      editorStyle="height: 250px"
      :class="{
        'p-invalid': submitted && showEditor && isEventExternal(),
      }"
    >
      <template v-slot:toolbar>
        <span class="ql-formats">
          <button class="ql-bold" v-tooltip.bottom="'Negrito'"></button>
          <button class="ql-italic" v-tooltip.bottom="'Italico'"></button>
          <button class="ql-underline" v-tooltip.bottom="'Sublinhado'"></button>
          <button
            class="ql-list"
            value="ordered"
            v-tooltip.bottom="'Lista Numeral'"
          ></button>
          <button
            class="ql-list"
            value="bullet"
            v-tooltip.bottom="'Lista de Marcadores'"
          ></button>
        </span>
      </template>
    </Editor>
    <small class="p-error" v-if="submitted && showEditor && isEventExternal()"
      >Para eventos <b> externos </b> é obrigatorio informar a lista de
      participantes.</small
    >
  </div>
</template>

<script>
//Models
import Event from "../../../../src/models/internal/event";
//VALIDATIONS
import { useVuelidate } from "@vuelidate/core";
import { required, requiredIf } from "@vuelidate/validators";
import { between } from "vuelidate/lib/validators";

//Services
import LocalService from "../../../../src/service/internal/local/local_service";
import EquipamentService from "../../../../src/service/internal/equipament/equipament_service";

//Enums
import { TypeEvent } from "../../../models/enums/type_event";
import { StatusEvent } from "../../../models/enums/status_event";

export default {
  props: ["event", "submitted"],
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      locals: [],
      equipaments: [],
      localService: new LocalService(),
      equipamentService: new EquipamentService(),
      types: TypeEvent,
      statusEvent: StatusEvent,
      showEditor: false,
      capMin: null,
      capMax: null,
    };
  },
  validations() {
    let validationReturn = {
      event: new Event().validations(),
    };
    if (this.$route.name !== "eventos") {
      validationReturn.event.pae = { required };
    }
    validationReturn.event.observation = {
      required: requiredIf(() => this.event.status === "CANCELED"),
    };
    validationReturn.event.nparticipants = {
      required,
      between(value) {
        return between(this.capMin, this.capMax)(value);
      },
    };
    validationReturn.event.pae = {
      required: requiredIf(() => this.event.local.name === "AUDITÓRIO"),
    };

    validationReturn.event.participants = {
      required: requiredIf(() => this.event.type === "EXTERNAL"),
    };

    return validationReturn;
  },
  mounted() {
    this.getLocals();
    this.getEquipaments();
    if (this.event.id) {
      this.setParticipants();
    }
    if (this.v$.event.local.$model) {
      this.capMin = this.v$.event.local.$model.capMin;
      this.capMax = this.v$.event.local.$model.capMax;
    }
  },
  methods: {
    getLocals() {
      this.localService.findAll().then((data) => {
        this.locals = data.filter((element) => element.status === true);
      });
    },
    getEquipaments() {
      this.equipamentService.findAll().then((data) => {
        this.equipaments = data.filter((element) => element.status === true);
      });
    },
    changeShowEditor(value) {
      if (value === "EXTERNAL") {
        this.showEditor = true;
      } else {
        this.showEditor = false;
      }
    },
    setParticipants() {
      this.capMin = this.v$.event.local.$model.capMin;
      this.capMax = this.v$.event.local.$model.capMax;
      const initialValue = this.v$.event.$model.nparticipants;
      this.v$.event.$model.nparticipants = {
        required,
        between: between(this.capMin, this.capMax),
      };
      this.v$.event.nparticipants.$model = initialValue;
    },
    // obrigatoriedade de PAE de acordo com local
    isPaeRequired() {
      return (
        this.v$.event.local.$model &&
        this.v$.event.local.$model.name === "AUDITÓRIO"
      );
    },
    isEventExternal() {
      return (
        this.v$.event.type.$model && this.v$.event.type.$model === "EXTERNAL"
      );
    },
  },
};
</script>
